import { render, staticRenderFns } from "./GeofenceNotificationDetail.vue?vue&type=template&id=13454707&"
import script from "./GeofenceNotificationDetail.vue?vue&type=script&lang=ts&"
export * from "./GeofenceNotificationDetail.vue?vue&type=script&lang=ts&"
import style0 from "./GeofenceNotificationDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports